require('./ctxExport.style.scss');

class CtxExportController {
    constructor($scope, utilsService, $document, $element, $filter, crudService) {
        this.utilsService = utilsService;
        this.$filter = $filter;
        this.crudService = crudService;

        this.toggleSelect = () => this.isPopupVisible = !this.isPopupVisible;
        $document.on('mousedown', (e) => {
            if ($element !== e.target && !$element[0].contains(e.target)) {
                $scope.$apply(() => {
                    $scope.$eval(this.isPopupVisible = false);
                });
            }
        });

        this.exportTypes = [
            {id: 1, title: $filter('translate')('ctxExport.json.current.label'), format: 'json', type: 'current'},
            {id: 2, title: $filter('translate')('ctxExport.json.all.label'), format: 'json', type: 'all'},
            {id: 3, title: $filter('translate')('ctxExport.csv.current.label'), format: 'csv', type: 'current'},
            {id: 4, title: $filter('translate')('ctxExport.csv.all.label'), format: 'csv', type: 'all'}
        ]
    }

    export(format, type) {
        this.onExport({type: type}).then(res => {
            if(!res || res.length === 0) return;
            let data;
            // format output based on file type
            switch (format) {
                case 'csv':
                    data = d3.csv.format(res);
                    break;
                case 'json':
                    data = JSON.stringify(res);
                    break;
                default:
                    data = res;
                    break
            }
            let date = '_' + this.$filter('date')(new Date(), 'yyyyMMdd_HHmmss', 'UTC');
            this.utilsService.saveData(data, `${this.fileName}_${type}${date}.${format}`, format);
            this.isPopupVisible = false;
        });
    }

}

CtxExportController.$inject = ['$scope','utilsService', '$document', '$element', '$filter', 'crudService'];
const ctxExportComponent = {
    controller: CtxExportController,
    scope: {},
    template: require('./ctxExport.template.html'),
    bindings: {
        fileName: '@',
        onExport: '&',
        state: '<'
    }
};

module.exports = ctxExportComponent;


// WEBPACK FOOTER //
// ./src/shared/ctxExport/ctxExport.component.js